/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import InsurancePolicy from './insurance-policy';
import InsurancePolicyDetail from './insurance-policy-detail';
import InsurancePolicyUpdate from './insurance-policy-update';
import InsurancePolicyDeleteDialog from './insurance-policy-delete-dialog';

const InsurancePolicyRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<InsurancePolicy />} />
    <Route path="new" element={<InsurancePolicyUpdate />} />
    <Route path=":id">
      <Route index element={<InsurancePolicyDetail />} />
      <Route path="edit" element={<InsurancePolicyUpdate />} />
      <Route path="delete" element={<InsurancePolicyDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default InsurancePolicyRoutes;
